import { downloadBlob, LocalizationService } from '@abp/ng.core';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, takeUntil } from 'rxjs';
import { HasSubscription } from 'src/ca-shared/ca-shared.module';
import { AutoUnsubscribe } from 'src/core/decorators/auto-unsubscribe.decorator';

@Component({
  selector: 'ca-audit-logging-excel-download',
  templateUrl: './audit-logging-excel-download.component.html',
  styleUrls: ['./audit-logging-excel-download.component.scss'],
  standalone: false,
})
@AutoUnsubscribe()
export class AuditLoggingExcelDownloadComponent extends HasSubscription implements OnInit {
  infoLabel = '';
  isCompleted = false;
  isFailure = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private localizationService: LocalizationService,
    private http: HttpClient,
  ) {
    super();

    this.infoLabel = this.localizationService.instant(
      'Conversation::DownloadWillStartAutomatically',
    );
  }

  ngOnInit(): void {
    const fileName = this.route.snapshot.params.fileName;

    var sub = this.http.get<File>(`api/audit-logging/audit-logs/download-excel/${fileName}`, {
      responseType: 'blob' as 'json',
    }) as unknown as Observable<File>;

    sub.pipe(takeUntil(this.autoUnsubscribeNotifier)).subscribe({
      next: result => {
        if (result.size > 0) {
          downloadBlob(result, fileName);
          this.isCompleted = true;
          this.infoLabel = this.localizationService.instant(
            'Conversation::RedirectionAfterDownloadCompleted',
          );
          setTimeout(() => {
            this.router.navigate(['/']);
          }, 1000);
        }
      },
      error: () => {
        this.isFailure = true;
        this.infoLabel = this.localizationService.instant('Conversation::DownloadFileError');

        setTimeout(() => {
          this.infoLabel = this.localizationService.instant('Conversation::RedirectionToHomePage');

          setTimeout(() => {
            this.router.navigate(['/']);
          }, 1000);
        }, 3000);
      },
    });
  }
}
